'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RuleKind() {
}
export { $c_Lpresto_types$RuleKind as $c_Lpresto_types$RuleKind };
$p = $c_Lpresto_types$RuleKind.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleKind;
/** @constructor */
function $h_Lpresto_types$RuleKind() {
}
export { $h_Lpresto_types$RuleKind as $h_Lpresto_types$RuleKind };
$h_Lpresto_types$RuleKind.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=presto.types$-Rule-Kind.js.map
